import { get } from 'lodash';
import { connect } from 'react-redux';
import { checkUser, oktaLoginAction } from '../../../services/appServices';
import App from './AppComponent';

const mapStateToProps = (state) => {
  const { user, app, i18nReducer, shared } = state;
  return {
    userInfo: user.userInfo,
    userPermission: user.userPermission,
    isAppLoading: app.isAppLoading,
    showToastMessage: shared.showToastMessage,
    isMiniAppLoading: app.isMiniAppLoading,
    content: get(i18nReducer.dictionaries[i18nReducer.currentLanguage], shared.code),
    uuidNumber: shared.uuidNumber,
    isReactTesting: false,
  }
};


const mapDispatchToProps = dispatch => {
  let actions = {
    checkUser: () => dispatch(checkUser()),
    oktaLogin: (data, cb) => oktaLoginAction(data, dispatch, cb)
  }
  return { ...actions, dispatch };
}


const AppContainer = connect(mapStateToProps, mapDispatchToProps)(App);

export default AppContainer;